const TIME_ZONE_SUFFIX = /(?:Z|[+-]\d{2}:?\d{2})$/i

const parseUtcDate = (date: string): Date => new Date(TIME_ZONE_SUFFIX.test(date) ? date : `${date}Z`)

export default parseUtcDate
